import React from "react";
import { Routes, Route, BrowserRouter, useParams } from "react-router-dom";
import Events from "./Events";
import Admins from "./Admins";
import Login from "./Login";
import Logout from "./Logout";
import Logfile from "./Logfile";
import Datafile from "./Datafile";
import Zipfile from './Zipfile';

function MyEvents(props) {
	const { mypage } = useParams();
	return <Events page={mypage}/>
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Events />} />
	    <Route path="/events/:mypage" element={<MyEvents />} />
	    <Route path="/admins" element={<Admins />} />
        <Route path="/login" element={<Login />} />
        <Route path="/logfile/:uuid" element={<Logfile />} />
        <Route path="/datafile/:uuid" element={<Datafile />} />
        <Route path="/zipfile/:uuid" element={<Zipfile />} />
        <Route path="/logout" element={<Logout />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
